export enum DocumentState {
    OPEN = "OPEN",
    CLOSED = "CLOSED"
}

export enum DocumentTypes {
    DEFAULT = "Obecny_dokument",
}

export enum DocumentClass {
    PUBLIC = "class_public"
}

export enum DocumentRank {
    PUBLIC = "rank_public",
    SECRET = "rank_secret"
}

export enum Environments {
    "devSofa" = "e8a2ebc6768e4912989b31452b914e39",
    "preSofa" = "4cb5bf38003944188ebf89f87791c669",
    "testSofa" = "7470254525814095af9a3863fc4c9409",
    "Sofa" = "95404ad7c7cb485e954fc31208d1b501",
}
